import { connect } from 'react-redux';
import { applySpec, compose, path, pipe } from 'ramda';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { createMatchSelector } from 'connected-react-router';
import { show as showModal } from 'redux-modal';

import withPageLoader from 'components/withPageLoader';
import { getPatientShouldShowLoading, getPatientName } from 'store/selectors/patientsData';
import CardiovascularReports from 'components/CardiovascularReports';
import { isResearcher, getUserId } from 'store/selectors/user';
import { CVI_TYPES } from 'constants/medical';
import { getPatientPageUrlId } from 'store/selectors/router';
import { requestPatientsData } from 'store/actionCreators/patientsData';
import { DELETE_CARDIO_VASCULAR_REPORT } from 'constants/modals';
import { reportsDownloadPdf } from 'store/actionCreators/reports/singleItems';

const mapStateToProps = applySpec({
  isAvailableManageReports: isResearcher,
  userId: getUserId,
  reportTypes: () => String(CVI_TYPES),
  patientId: getPatientPageUrlId,
  patientName: (
    state,
    {
      match: {
        params: { id },
      },
    },
  ) => getPatientName(id)(state),
});

const mapDispatchToProps = dispatch => ({
  handleDownloadDocument: id => () =>
    dispatch(
      reportsDownloadPdf({
        url: `DocumentReference/${id}`,
      }),
    ),

  handleRemoveReportClick: id => () => {
    dispatch(showModal(DELETE_CARDIO_VASCULAR_REPORT, { reportId: id }));
  },
});

export default compose(
  withTranslation(),
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withPageLoader({
    loadingSelector: (
      state,
      {
        match: {
          params: { id },
        },
      },
    ) => getPatientShouldShowLoading(id)(state),
    initialActionArgsSelector: applySpec({
      id: pipe(
        createMatchSelector('/patient/:id'),
        path(['params', 'id']),
      ),
    }),
    initialAction: requestPatientsData,
  }),
)(CardiovascularReports);
